enum Portfolio {
  Standard = "Standard",
  Game = "Game"
}
export default Portfolio;